import { render } from "./AppFooter.vue?vue&type=template&id=6e076e73"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=6e076e73&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__